import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import LoginBtn from '../loginBtn';

/**
 * for this page
 */
// import Content from './content/';

class Home extends React.PureComponent {
    static propTypes = {
        windowHeight: PropTypes.number,
        openModal: PropTypes.func
    };

    top = null; // 当前滚动条位置
    timer = null; // 返回顶部定时器
    speed = null; // 返回顶部速度
    state = {
        windowHeight: this.props.windowHeight,
    };

    static getDerivedStateFromProps = (props, state) => {
        let resWHeight = {};

        if (props.windowHeight !== state.windowHeight) {
            resWHeight = { windowHeight: props.windowHeight };
        }

        return { ...resWHeight };
    };

    // 返回顶部动画
    animateGo = () => {
        const { windowHeight } = this.state;

        this.top = this.top + this.speed;
        if (this.top >= windowHeight) {
            window.scroll(0, windowHeight);
        } else {
            window.scroll(0, this.top);
            this.timer = setTimeout(this.animateGo, 1);
        }
    };
    // 点击返回顶部，0.3s内返回到顶部
    handleGoClick = event => {
        const { windowHeight } = this.state;
        const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

        this.speed = windowHeight / 60;
        this.top = scroll;
        this.timer = setTimeout(this.animateGo, 1);
    };

    render() {
        /**
         * 组件分发数据
         */
        const { windowHeight } = this.state;

        return (
            <div className={styles.home} style={{ height: `${windowHeight}px` }}>
                <div className={'container'} style={{ position: 'relative', height: '100%' }}>
                    <h1 className={styles.logoBox} title={'大风号内容开放平台'} />
                    <div className={styles.dec}>
                        <div className={`${styles.btnWrapper} clearfix`}>
                            <span className={styles.register} onClick={this.props.openModal}>
                                注册
                            </span>
                            <LoginBtn configClass={styles.login} txt={'登录'} openModal={this.props.openModal} />
                        </div>
                    </div>
                    <a href="//feng.ifeng.com" className={styles.toFeng} />
                    <div className={styles.arrow} onClick={this.handleGoClick} />
                    <div className={styles.art_map} />
                    <div className={styles.art_pic} />
                </div>
                <div className={styles.cloud1} />
                <div className={styles.cloud2} />
            </div>
        );
    }
}

export default errorBoundary(Home);
